import { render, staticRenderFns } from "./ViTeacherAcademicManagementContribution.vue?vue&type=template&id=42841c33"
import script from "./ViTeacherAcademicManagementContribution.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementContribution.vue?vue&type=script&lang=js"
import style0 from "./ViTeacherAcademicManagementContribution.vue?vue&type=style&index=0&id=42841c33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports